import React from 'react'
import PropTypes from 'prop-types'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from '@chakra-ui/react'

import '../theme.css'

const AccordionContainer = ({
  title,
  isChild,
  children,
  isDisabled,
  ...rest
}) => {
  return (
    <Accordion
      reduceMotion
      defaultIndex={[0]}
      allowMultiple
      data-test-id="AccordionContainer"
      {...rest}>
      <AccordionItem
        // isDisabled={isDisabled}
        borderTop="none"
        _last={{
          borderBottomWidth: '0',
        }}>
        <AccordionButton
          p={'24px 0 24px 0'}
          borderBottom={'1px solid'}
          borderColor={isChild ? 'transparent' : 'rgba(0, 0, 0, .05)'}
          _hover={{
            backgroundColor: 'none',
          }}>
          <Box
            flex="1"
            textAlign="left"
            textStyle={isChild ? 'childChartHeader' : 'chartGroupHeader'}>
            {title}
          </Box>
          {isDisabled ? null : <AccordionIcon />}
        </AccordionButton>
        <AccordionPanel p="0">{children}</AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
AccordionContainer.displayName = 'AccordionContainer'

AccordionContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  isChild: PropTypes.bool,
}

export default AccordionContainer
